import React from 'react';
import { Link } from 'react-router-dom';

/**
 * KDS button rendered as a link. Internal `to` paths use React Router; `href`
 * renders a plain anchor (mailto, download, external).
 *
 * Variant names follow Material 3 (filled / tonal / elevated / outlined /
 * text). The legacy portfolio names are kept as aliases so existing callers
 * keep working.
 */
const VARIANTS = {
  filled: 'kds-btn--filled',
  tonal: 'kds-btn--tonal',
  elevated: 'kds-btn--elevated',
  outlined: 'kds-btn--outlined',
  text: 'kds-btn--text',
  primary: 'kds-btn--filled',
  secondary: 'kds-btn--outlined',
  ghost: 'kds-btn--text',
};

export default function Button({
  to,
  href,
  variant = 'filled',
  size,
  className = '',
  children,
  external = false,
  ...rest
}) {
  const classes = [
    'kds-btn',
    VARIANTS[variant] || VARIANTS.filled,
    size === 'sm' ? 'kds-btn--sm' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  if (to) {
    return (
      <Link to={to} className={classes} {...rest}>
        {children}
      </Link>
    );
  }

  const externalProps = external ? { target: '_blank', rel: 'noopener noreferrer' } : {};
  return (
    <a href={href} className={classes} {...externalProps} {...rest}>
      {children}
    </a>
  );
}
